import type { PriceItemType } from 'core/accounting/domain/PriceItemType'
import type { StopType } from 'core/domain/Stop'

export type RateLine = {
  quantity: number
  subtype?: string
  total: number
  type: {
    value: string
    label: string
  }
  unitPrice: number
  notes?: string
  priceItemType?: Omit<PriceItemType, 'stopsRelationship'>
  stopType?: StopType
}

export const RateLineTypes = {
  ACCESORIAL: { value: 'accessorial', label: 'Accessorial' },
  ALL_IN: { value: 'all_in', label: 'All-In' },
  HAUL: { value: 'haul', label: 'Haul' },
}

export function getFlatRate(ratelines?: Array<RateLine>) {
  if (!ratelines) {
    return undefined
  }

  return ratelines.find(
    rateline =>
      rateline.type.value === RateLineTypes.HAUL.value ||
      rateline.type.value === RateLineTypes.ALL_IN.value
  )?.total
}
